"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WorkflowDesignerWorkareaModel = /** @class */ (function () {
    function WorkflowDesignerWorkareaModel(viewport) {
        this.viewport = viewport;
    }
    Object.defineProperty(WorkflowDesignerWorkareaModel.prototype, "left", {
        get: function () {
            var out = null;
            this.viewport.process.states.forEach(function (state) {
                if (out === null || state.x < out) {
                    out = state.x;
                }
            });
            return (out || 0) - 20;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerWorkareaModel.prototype, "right", {
        get: function () {
            var out = null;
            this.viewport.process.states.forEach(function (state) {
                if (out === null || state.x + state.width > out) {
                    out = state.x + state.width;
                }
            });
            return (out || 0) + 20;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerWorkareaModel.prototype, "top", {
        get: function () {
            var out = null;
            this.viewport.process.states.forEach(function (state) {
                if (out === null || state.y < out) {
                    out = state.y;
                }
            });
            return (out || 0) - 20;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerWorkareaModel.prototype, "bottom", {
        get: function () {
            var out = null;
            this.viewport.process.states.forEach(function (state) {
                if (out === null || state.y + state.height > out) {
                    out = state.y + state.height;
                }
            });
            return (out || 0) + 20;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerWorkareaModel.prototype, "width", {
        get: function () {
            return this.right - this.left;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerWorkareaModel.prototype, "height", {
        get: function () {
            return this.bottom - this.top;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerWorkareaModel.prototype, "centerX", {
        get: function () {
            return this.left + (this.right - this.left) / 2;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerWorkareaModel.prototype, "centerY", {
        get: function () {
            return this.top + (this.bottom - this.top) / 2;
        },
        enumerable: true,
        configurable: true
    });
    return WorkflowDesignerWorkareaModel;
}());
exports.WorkflowDesignerWorkareaModel = WorkflowDesignerWorkareaModel;
//# sourceMappingURL=workflow-designer-workarea.model.js.map